import { InputAdornment, TextField } from "@mui/material";
import React, { useEffect, useState } from "react";
import { SetterOrUpdater } from "recoil";

interface MaxFieldProps {
  filters: number[];
  unitsForVoltageAndKw: string;
  valueSetter?: SetterOrUpdater<number[]>;
}

const MaxField: React.FC<MaxFieldProps> = ({ filters, unitsForVoltageAndKw, valueSetter }) => {
  const [value, setValue] = useState<number>(filters[1]);
  useEffect(() => {
    if (filters && filters.length > 0) {
      setValue(filters[1]);
    }
  }, [filters]);
  return (
    <TextField
      label="max"
      type="text"
      variant="outlined"
      InputLabelProps={{ shrink: true }}
      sx={{
        width: "30%",
        borderRadius: "0px",
        ".MuiOutlinedInput-root": {
          borderRadius: "0px",
        },
      }}
      value={value}
      onChange={(e) => setValue(parseInt(e.target.value))}
      onBlur={(e) => valueSetter && valueSetter([filters[0], parseInt(e.target.value)])}
      InputProps={{
        endAdornment: <InputAdornment position="start">{unitsForVoltageAndKw}</InputAdornment>,
      }}
      size="small"
    />
  );
};

export default MaxField;
